import React from 'react';
import { useIntl } from 'react-intl';
import { Modal } from "@ignitesales/neuro-application/src/neuro-ui";
import FormContainer from '@ignitesales/neuro-application/src/neuro-guide/components/Forms/FormContainer';
import FormInput from '@ignitesales/neuro-application/src/neuro-guide/components/Forms/FormInput';
import { sendToBottomLine } from '../utils/contactFormProcess';
import { contactLeadUpdate, formatPhoneNumberField, useDispatch } from '@ignitesales/neuro-application';


const ContactForm = ({ className = '', active, onClose, productCart, marketSelected }) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const contactFormFields = {
        firstName: {
            name: 'firstName',
            type: 'text',
            required: true
        },
        lastName: {
            name: 'lastName',
            type: 'text',
            required: true
        },
        emailAddress: {
            name: 'email',
            type: 'email',
            required: true,
            isEmail: true
        },
        phoneNumber: {
            name: 'phone',
            type: 'text',
            isPhoneNumber: true,
            required: true,
        }
    };
    const formId = 'contactMeForm';
    const getContactFields = () => defaultConsumerFields;
    const defaultConsumerFields = [
        contactFormFields.firstName,
        contactFormFields.lastName,
        contactFormFields.emailAddress,
        contactFormFields.phoneNumber
    ];

    const renderedFields = getContactFields().map((fieldProps, index) =>
        <FormInput formId={formId} key={index} errorPositionAfterInput={true} {...fieldProps} />
    );

    const formSubmitted = (dataForm) => {
        // Triggers for lead processors
        const lead = { ...dataForm };
        lead.phone = formatPhoneNumberField(lead.phone); 
        // Note: looks like sendToLeadProcessor needs more configs and contactLeadUpdate seems to be the one actually triggering processors for Central
        dispatch(contactLeadUpdate({ contactLead: lead }));
        sendToBottomLine(dataForm, productCart, marketSelected);
    };

    return <Modal
        show={active}
        className={`${className} contactFormModal`}
        title={<h1>{intl.formatMessage({ id: 'summary.yourContactForm' })}</h1>}
        onClose={onClose}
        nodeId="root"
        closeBtn={<i className="fa fa-close" />}
    >
        <div className="contactFormModal">
            <FormContainer className="contactMe__form" onSubmit={formSubmitted} formId={formId} renderDefaultSubmit={true}>
                <div className="form-body">{renderedFields}</div>
            </FormContainer>
        </div>
    </Modal>;
};

export default ContactForm;